import CookiesPolicy, {
  BACKEND_IDENTIFIER as COOKIES_BACKEND_IDENTIFIER,
  NAME as COOKIES_NAME
} from './CookiesPolicy'
import PrivacyPolicy, {
  BACKEND_IDENTIFIER as PRIVACY_BACKEND_IDENTIFIER,
  NAME as PRIVACY_NAME
} from './PrivacyPolicy'
import React, { Component } from 'react'
import UsersLicense, {
  BACKEND_IDENTIFIER as USERS_LICENSE_BACKEND_IDENTIFIER,
  NAME as USERS_LICENSE_NAME
} from './UsersLicense'

import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControlLabel from '@mui/material/FormControlLabel'

export {
  COOKIES_BACKEND_IDENTIFIER,
  COOKIES_NAME,
  PRIVACY_BACKEND_IDENTIFIER,
  PRIVACY_NAME,
  USERS_LICENSE_BACKEND_IDENTIFIER,
  USERS_LICENSE_NAME
}

class EulaDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cookiesHeight: 0,
      usersHeight: 0,
      privacyHeight: 0,
      title: 'POLÍTICA DE COOKIES',
      hasScrolledEnough: false,
      checked: false
    }

    this.dialogRef = React.createRef()

    this.handleScroll = this.handleScroll.bind(this)
    this.onAccept = this.onAccept.bind(this)
    this.onToggle = this.onToggle.bind(this)
    this.checkScrollStatus = this.checkScrollStatus.bind(this)
  }

  handleScroll() {
    if (!this.dialogRef.current) return

    const y = this.dialogRef.current.scrollTop
    const { scrollHeight, clientHeight } = this.dialogRef.current
    const maxScroll = scrollHeight - clientHeight

    const title = y > this.state.cookiesHeight + this.state.usersHeight
      ? 'POLÍTICA DE PRIVACIDADE'
      : y > this.state.cookiesHeight
        ? 'TERMOS DE USO ("TERMO")'
        : 'POLÍTICA DE COOKIES'

    const hasScrolledEnough = maxScroll <= 10 || y >= maxScroll * 0.9

    this.setState({ title, hasScrolledEnough })
  }

  checkScrollStatus() {
    if (!this.dialogRef.current) return

    const { scrollHeight, clientHeight } = this.dialogRef.current
    const maxScroll = scrollHeight - clientHeight

    if (maxScroll <= 10) {
      this.setState({ hasScrolledEnough: true })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ hasScrolledEnough: false, checked: false })
      setTimeout(() => this.checkScrollStatus(), 500)
    }

    const heightsChanged =
      prevState.cookiesHeight !== this.state.cookiesHeight ||
      prevState.usersHeight !== this.state.usersHeight ||
      prevState.privacyHeight !== this.state.privacyHeight

    if (heightsChanged) {
      setTimeout(() => this.checkScrollStatus(), 100)
    }
  }

  onAccept() {
    if (this.props.onAccept) {
      this.props.onAccept()
    }
    this.setState({
      hasScrolledEnough: false,
      checked: false
    })
  }

  onToggle() {
    this.setState({ checked: !this.state.checked })
  }

  render() {
    const canAccept = this.state.hasScrolledEnough
    const acceptEnabled = canAccept && this.state.checked

    return (
      <Dialog
        disableEscapeKeyDown
        fullWidth
        maxWidth='xl'
        aria-labelledby='confirmation-dialog-title'
        open={this.props.visible}
        scroll='paper'
        sx={{ maxWidth: '1200px', mx: 'auto' }}
      >
        <DialogTitle id='title' sx={{ color: 'text.secondary' }}>
          {this.state.title}
        </DialogTitle>
        <DialogContent
          ref={this.dialogRef}
          onScroll={this.handleScroll}
        >
          <CookiesPolicy
            onHeight={height => this.setState({ cookiesHeight: height })}
          />
          <UsersLicense
            onHeight={height => this.setState({ usersHeight: height })}
          />
          <PrivacyPolicy
            onHeight={height => this.setState({ privacyHeight: height })}
          />
        </DialogContent>
        <DialogActions>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.checked}
                onChange={this.onToggle}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                disabled={!canAccept}
                color='primary'
              />
            }
            label='Eu li e aceito os termos de utilização.'
          />
          <Button
            key='accept_button'
            autoFocus
            onClick={this.onAccept}
            color='primary'
            disabled={!acceptEnabled}
          >
            ACEITO
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default EulaDialog
